import React from 'react';
import { Text } from 'react-native';
import { View } from 'react-native-web';
import { DraggableGrid } from 'react-native-draggable-grid';
import LinkTextButton from '../Buttons/LinkTextButton';
import { drag_services_reorder, edit_order } from '../../../utils/DictionaryManagementUtils';
import EditOrderPanelButton from '../Buttons/EditOrderPanelButton';
import Title from '../Text/Title';
import MyAddServicePopup from '../../MyAddServicePopup';
import MyDeleteQuestionPopup from '../../MyDeleteQuestionPopup';

//= ========================================================================

const ServicesMenu = ({
  globJSON,
  headline,
  state,
  renderItem,
  onDragReleased,
  onSaveEditOrderPressed,
  onCancelEditOrderPressed,
  onStartEditOrderPressed,
  draggingState,
  language,
  addServicePopupState, onDuplicateFlowService, setAddServicePopupState, deleteServicePopupState, onDeleteDuplicatedFlowService,
  setDeleteServicePopupState,
}) => {
  const height = Math.ceil(globJSON.configurations.services.screens_ordering.length / 3) * 120
      + (draggingState.nowDragging ? 120 : 0);
  const myStyles = {
    serviceText: {
      marginBottom: 24,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 18,
      color: '#001a2f',
    },
    editMatrix: {
      padding: 5,
      backgroundColor: draggingState ? '#f7fafc' : null,
    },
    flexComponent: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    draggable: { height },
  };

  return (
    <View>
      <View style={myStyles.flexComponent}>
        <Title marginBottom={30} isBold>{headline}</Title>
        {!draggingState && (<LinkTextButton onPress={onStartEditOrderPressed}>{edit_order}</LinkTextButton>)}
      </View>
      <View style={myStyles.editMatrix}>
        {draggingState && <Text style={myStyles.serviceText}>{drag_services_reorder}</Text>}
        <View style={myStyles.draggable}>
          <DraggableGrid
            numColumns={3}
            renderItem={renderItem}
            itemHeight={120}
            data={state}
            onDragRelease={(data) => {
              onDragReleased(data);
            }}
          />
        </View>
        {draggingState && <EditOrderPanelButton onPressSave={onSaveEditOrderPressed} onPressCancel={onCancelEditOrderPressed} language={language} />}
      </View>

      {deleteServicePopupState.isDeleteServiceVisible && (
      <View style={{ zIndex: 2, position: 'absolute' }}>
        <MyDeleteQuestionPopup
          onYesPressed={(service) => {
            onDeleteDuplicatedFlowService(service);
            setDeleteServicePopupState({
              isDeleteServiceVisible: false,
              service: null,
            });
          }}
          onNoPressed={() => setDeleteServicePopupState({
            isDeleteServiceVisible: false,
            service: null,
          })}
          service={deleteServicePopupState.service}
          language={language}
        />
      </View>
      )}

      {addServicePopupState.isAddServiceVisible && (
      <View style={{ zIndex: 2, position: 'absolute' }}>
        <MyAddServicePopup
          onYesPressed={(service, name) => {
            onDuplicateFlowService(service, name);
            setAddServicePopupState({
              isAddServiceVisible: false,
              service: null,
            });
          }}
          onNoPressed={() => setAddServicePopupState({
            isAddServiceVisible: false,
            service: null,
          })}
          globJSON={globJSON}
          language={language}
          service={addServicePopupState.service}
        />
      </View>
      )}
    </View>
  );
};
export default ServicesMenu;
